import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import CuisineCard from '../../components/CuisineCard';
import ResponsiveGridLayout from '../../components/ResponsiveGridLayout';
import i18n from '../../utils/i18n';

import { urlWithLocale } from '../../utils/locale';
import styles from './styles.scss';

const INITIAL_MAX_CUISINES = 3;

export class RecommendedCuisinesContainer extends React.Component {
  state = {
    isExpanded: false,
    hasMounted: false,
  };

  /**
   * Allow us to set CSS properties for some elements only after the page has
   * initially mounted.
   */
  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  onClickViewAll = () => {
    this.setState({ isExpanded: true });
  };

  render() {
    const { recommendedCuisines } = this.props;
    const { isExpanded, hasMounted } = this.state;
    const maxVisibleCuisines = isExpanded ? recommendedCuisines.length : INITIAL_MAX_CUISINES;
    const canExpand = hasMounted && !isExpanded && maxVisibleCuisines < recommendedCuisines.length;

    const viewAll = (
      <div className={styles.viewAll}>
        <Button type="secondary" size="small" onClick={this.onClickViewAll}>
          {i18n.gettext('landingPage.cuisine.recommendedCuisines.viewAll')}
        </Button>
      </div>
    );

    if (recommendedCuisines.length === 0) {
      return null;
    }

    return (
      <Spacer spacing="x-large 0">
        <Heading color="black" level={2} size="x-small">
          <span className={styles.heading}>
            {i18n.gettext('landingPage.cuisine.recommendedCuisines.header')}
          </span>
        </Heading>
        <ResponsiveGridLayout gutter="large" maxColumns={3} minColumnWidth={260}>
          {recommendedCuisines.map(({ url, image, title, description }, index) => {
            const card = (
              <CuisineCard
                // eslint-disable-next-line react/no-array-index-key
                key={`recommended-cuisine-${title}-${index}`}
                url={url}
                imageUrl={image}
                title={title}
                description={description}
                linkText={i18n.gettext(
                  'landingPage.cuisine.recommendedCuisines.viewCuisine(%(cuisine)s)',
                  { cuisine: title },
                )}
              />
            );

            if (!hasMounted || index < maxVisibleCuisines) return card;

            return (
              // eslint-disable-next-line react/no-array-index-key
              <div className={styles.hidden} key={`hidden-recommended-cuisine-${title}-${index}`}>
                {card}
              </div>
            );
          })}
        </ResponsiveGridLayout>
        {canExpand && viewAll}
      </Spacer>
    );
  }
}

RecommendedCuisinesContainer.propTypes = {
  recommendedCuisines: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ),
};

RecommendedCuisinesContainer.defaultProps = {
  recommendedCuisines: [],
};

const mapStateToProps = (state) => ({
  recommendedCuisines: state.cuisine.recommendedCuisines.map((cuisine) => ({
    ...cuisine,
    url: urlWithLocale(state.request.country, cuisine.url, state.request.locale),
  })),
});

export default connect(mapStateToProps)(RecommendedCuisinesContainer);
